import { PaymentMethodTable } from "@app/components/table/billingTable/PaymentMethodTable";
import { MainContentContainer } from "@app/components/MainContainer";
import { MainContent } from "@app/components/MainContainer/MainContent";
import { MainDescription } from "@app/components/MainContainer/MainDescription";
import { MainHeader } from "@app/components/MainContainer/MainHeader";
import { MainTitle } from "@app/components/MainContainer/MainTitle";
import { CommonErrorModal } from "@app/components/modals/CommonErrorModal";
import { CommonSelectModal } from "@app/components/modals/CommonModal";
import { PaymentMethodModal } from "@app/components/modals/PaymentModal";
import { useModal, Button } from "@shortsworks/ui";
import {
  useDeletePaymentMethod,
  useGetUserInfo,
  useUpdateDefaultMethod,
  useGetAccountPaymentMethod,
} from "@shortsworks/user-api";
import { useQueryClient } from "@tanstack/react-query";
import {LoaderCircle} from "lucide-react"
import {Children, Fragment} from "react"

// useTable 형태로 변경
export const PaymentMethods = () => {
  const { showModal } = useModal();

  const queryClient = useQueryClient();
  const { data: userInfoData, isSuccess: isSuccessGetUserInfo } =
    useGetUserInfo();
  const {
    data: accountPaymentMethodData,
    queryKey: accountPaymentMethodQueryKey,
    isSuccess: isSuccessGetAccountPaymentMethod,
  } = useGetAccountPaymentMethod();
  const { mutateAsync: mutateAsyncUpdateDefaultMethod } =
    useUpdateDefaultMethod({
      mutation: {
        onSuccess: () => {
          return queryClient.invalidateQueries({
            queryKey: accountPaymentMethodQueryKey,
          });
        },
      },
    });
  const deletePaymentMethod = useDeletePaymentMethod({
    mutation: {
      onSuccess: () => {
        return queryClient.invalidateQueries({
          queryKey: accountPaymentMethodQueryKey,
        });
      },
    },
  });

  if (!isSuccessGetAccountPaymentMethod) {
    return (
        <div className="flex flex-shrink items-center justify-center sm:h-dvh md:h-36">
          <LoaderCircle className="w-6 h-6 mr-2 animate-spin" />
        </div>
    );
  }

  const handleRegisterPaymentMethod = () => {
    return showModal(PaymentMethodModal);
  };

  const setDefaultCard = async (cardId: string) => {
    if (!isSuccessGetUserInfo) {
      return showModal(CommonErrorModal, {
        title: "회원 정보를 가져오는 데 실패했습니다.",
      });
    }
    const modalResult = await showModal(CommonSelectModal, {
      title: "기본 카드로 설정하시겠습니까?",
    }).promise();
    if (modalResult.value) {
      const result = await mutateAsyncUpdateDefaultMethod({
        data: {
          id: cardId,
          account_id: userInfoData.data.accountId,
        },
      });
      if (!result.data.success) {
        return showModal(CommonErrorModal, {
          title: "기본 카드 변경에 실패했습니다.",
        });
      }
    }
  };

  const handleRemovePaymentMethod = async (cardId: string) => {
    let modalResult = await showModal(CommonSelectModal, {
      title: "해당 카드를 삭제하시겠습니까?",
    }).promise();
    if (!modalResult.value) {
      return;
    }
    const deletePaymentMethodResult = await deletePaymentMethod.mutateAsync({
      params: { method_id: cardId },
    });
    if (!deletePaymentMethodResult.data.success) {
      return showModal(CommonErrorModal, {
        title: "해당 카드를 삭제할 수 없습니다.",
      });
    }
  };

  // @ts-ignore
  const isExistPaymentMethod = accountPaymentMethodData?.data.length !== 0;


  return (
    <MainContentContainer>
      <MainHeader>
        <MainTitle>결제 카드</MainTitle>
        <MainDescription>구독에 사용할 카드를 설정해주세요.</MainDescription>
      </MainHeader>
      <MainContent>
        {/*<PaymentMethodTable data={accountPaymentMethodData?.data ?? []}/>*/}
        <div className="flex flex-col gap-4">
          {
              !isExistPaymentMethod &&
              <div>등록된 결제 카드가 없습니다.</div>
          }
          {
            isExistPaymentMethod &&
              <Fragment>
                {/*@ts-ignore: 타입 체크 필요  */}
                <PaymentMethodTable data={accountPaymentMethodData?.data ?? []}/>
                {
                  Children.toArray(
                      // @ts-ignore
                      accountPaymentMethodData.data.map((paymentMethod) => {
                        return (
                            <div className="flex flex-row items-center gap-4">
                              <div className="w-1/4">{paymentMethod.cardNumber}</div>
                              <div className="w-1/4">
                                {paymentMethod.cardExpirationMonth}/
                                {paymentMethod.cardExpirationYear}
                              </div>
                              <div className="w-1/4">
                                {paymentMethod.isDefault ? (
                                    <Button
                                        className="font-bold"
                                        disabled={true}
                                        variant="outline"
                                    >
                                      기본 결제 카드
                                    </Button>
                                ) : (
                                    <Button
                                        variant="outline"
                                        onClick={() => setDefaultCard(paymentMethod.id)}
                                    >
                                      결제 카드 설정
                                    </Button>
                                )}
                              </div>
                              <div className="w-1/4">
                                <Button
                                    className="w-32"
                                    variant="secondary"
                                    disabled={paymentMethod.isDefault}
                                    onClick={() => handleRemovePaymentMethod(paymentMethod.id)}
                                >
                                  삭제
                                </Button>
                              </div>

                            </div>
                        );
                      }),
                  )
                }
              </Fragment>
          }
        </div>
        <Button className="w-24 mt-10" onClick={handleRegisterPaymentMethod}>
          카드 추가
        </Button>
      </MainContent>
    </MainContentContainer>
  );
};
